import React, { useState } from 'react';
import { LoyaltyProgramModal } from './LoyaltyProgramModal';
import { ChevronRightIcon } from 'lucide-react';
interface LoyaltyProgram {
  id: string;
  name: string;
  nameAr: string;
  logo: string;
  color: string;
}
interface LoyaltyPointsSectionProps {
  onPointsApplied: (program: string, amount: number) => void;
}
export function LoyaltyPointsSection({
  onPointsApplied
}: LoyaltyPointsSectionProps) {
  const [selectedProgram, setSelectedProgram] = useState<LoyaltyProgram | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const loyaltyPrograms: LoyaltyProgram[] = [{
    id: 'tamayouz',
    name: 'Tamayouz',
    nameAr: 'Tamayouz',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Tamara_Logo.svg/2560px-Tamara_Logo.svg.png',
    color: 'bg-purple-600'
  }, {
    id: 'qitaf',
    name: 'Qitaf',
    nameAr: 'Qitaf',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Mada_Logo.svg/2560px-Mada_Logo.svg.png',
    color: 'bg-blue-600'
  }, {
    id: 'mokafaa',
    name: 'Mokafaa',
    nameAr: 'Mokafaa',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg',
    color: 'bg-indigo-600'
  }];
  const handleProgramClick = (program: LoyaltyProgram) => {
    setSelectedProgram(program);
    setModalOpen(true);
  };
  return <>
      <div className="bg-white rounded-lg shadow-sm p-4 md:p-6" data-id="element-1828" data-mp="2pvqwkvzskh3o">
        <h2 className="text-base md:text-lg font-bold mb-4" data-id="element-1829" data-mp="2px1wgkq494pi">Use Points</h2>
        <div className="grid grid-cols-3 gap-3 md:gap-4" data-id="element-1830" data-mp="2lufcf5zoso2v">
          {loyaltyPrograms.map(program => <button key={program.id} onClick={() => handleProgramClick(program)} className="border-2 border-gray-200 rounded-lg p-3 md:p-4 hover:border-[#1E2B55] transition-colors flex flex-col items-center justify-center gap-2 min-h-[80px] md:min-h-[100px]" data-id="element-1831" data-mp="2h0sxt89yqa4f">
              <div className="text-sm md:text-base font-bold text-[#1E2B55] text-center" data-id="element-1832" data-mp="34qn8bj6t7mli">
                {program.nameAr}
              </div>
              <div className="text-xs text-gray-500" data-id="element-1833" data-mp="3smryqbew3k46">{program.name}</div>
            </button>)}
        </div>
      </div>
      {selectedProgram && <LoyaltyProgramModal isOpen={modalOpen} onClose={() => {
      setModalOpen(false);
      setSelectedProgram(null);
    }} program={selectedProgram} onPointsApplied={onPointsApplied} data-id="element-1834" data-mp="3iy0buhoorq04" />}
    </>;
}